<template>
    <div class="page page-auth">
        <div class="background"></div>

        <div class="auth-card">
            <a
                href="#back"
                v-if="sent"
                class="back-button"
                @click.prevent="onUnsent"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 29.733 24.103"
                >
                    <g transform="rotate(90 14.867 14.867)">
                        <path
                            d="M3.261 15.273L9.745 8.79v20.943h4.612V8.993l6.484 6.485 3.259-3.262L12.012 0 0 12.012z"
                        ></path>
                    </g>
                </svg>
            </a>

            <component
                :is="component"
                @sent="onSent"
                @unsent="onUnsent"
                v-model="form"
            ></component>
        </div>
    </div>
</template>

<script>
import AppAuthLogin from "./Login";
import AppAuthCode from "./Code";

const defaultForm = {
    idNumber: "",
    phoneNumber: "",
    code: ""
};

export default {
    name: "app-auth",

    data() {
        return {
            sent: false,
            form: { ...defaultForm }
        };
    },

    methods: {
        async onSent() {
            await this.$nextTick();
            this.sent = true;
        },

        async onUnsent() {
            await this.$nextTick();
            this.form = { ...defaultForm };
            this.sent = false;
        }
    },

    computed: {
        component() {
            return this.sent ? "app-auth-code" : "app-auth-login";
        }
    },

    components: { AppAuthCode, AppAuthLogin }
};
</script>

<style lang="scss">
.application-page {
}

.page-auth {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
}

.auth-card {
    flex-grow: 1;
    flex-shrink: 1;
    height: 100%;
    width: 100%;
    max-width: 864px;
    max-height: 621px;
    border-radius: 69px;
    background-color: $white;
    position: relative;
    z-index: 5;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .back-button {
        display: block;
        width: 30px;
        height: 30px;
        position: absolute;
        right: 65px;
        top: 65px;

        svg {
            display: block;
            width: 100%;
            height: 100%;

            path {
                fill: $primary-blue;
            }
        }
    }

    .description-message {
        font-size: 20px;
        font-weight: bold;
        line-height: 1.3;
        color: $black;
        text-align: center;
        margin: 50px 0;
    }

    .card-header {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 85px;

        .icon {
            svg {
                display: block;
            }
        }

        .title {
            font-size: 25px;
            font-weight: bold;
            line-height: 1.32;
            color: $black;
            margin-top: 20px;
        }
    }
}
</style>
